import type { ItineraryImportSourceType } from '@/models/itineraryImportTypes';
import type { ItineraryImportSource } from '@/api/itineraryImport';
import { detectSocialPlatform } from '@/utils/platformDetection';
import { validateSocialMediaUrl } from '@/utils/urlValidation';

export function socialItineraryImportSourceTypeFromUrl(url: string): ItineraryImportSourceType | null {
  const platform = detectSocialPlatform(url);
  if (platform === 'instagram') return 'instagram';
  if (platform === 'tiktok') return 'tiktok';
  return null;
}

/** Social import review subtitle (Figma / product copy). */
export function formatSocialImportReviewSubtitle(
  placeCount: number,
  platform?: 'instagram' | 'tiktok' | null,
): string {
  const count = Math.max(0, placeCount);
  const placesWord = count === 1 ? 'place' : 'places';
  const medium = platform === 'tiktok' ? 'post' : 'reel';
  return `We found ${count} ${placesWord} in this ${medium}. Pick the ones you want, then save. We will drop you directly into the itinerary editing experience.`;
}

export function buildSocialItineraryImportSource(url: string): ItineraryImportSource | null {
  const validation = validateSocialMediaUrl(url.trim());
  if (!validation.isValid) return null;
  const normalized = validation.normalizedUrl ?? url.trim();
  const sourceType = socialItineraryImportSourceTypeFromUrl(normalized);
  if (sourceType !== 'instagram' && sourceType !== 'tiktok') return null;
  return { type: sourceType, url: normalized };
}
